import _ from 'lodash'
import { CATEGORY_TYPE, PROPOSAL_PHASE_TYPE } from '../app/constants/proposalTypes'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { getIsProposalTypeNewListing } from '@vzmi/shp_shared_compo/helpers/proposalHelpers'
import { UPDATE_IMAGE_V2, UPDATE_LISTING_ATTRIBUTE } from '../app/components/Proposal/UpdateListing/helpers/converters'

export const getCategoryType = categoryId => _.get(/(^.[A-Za-z]*)\d+/g.exec(_.toString(categoryId)), '1', null)
export const getCategoryTypeFlag = ({ categoryId, type }) => {
  const localCategoryType = categoryId ? getCategoryType(categoryId) : type
  return {
    isZone: localCategoryType === CATEGORY_TYPE.ZONE,
    isSub: localCategoryType === CATEGORY_TYPE.SUB,
    isCat: localCategoryType === CATEGORY_TYPE.CAT,
    isCatItem: localCategoryType === CATEGORY_TYPE.CAT_ITEM,
    isAttrCluster: localCategoryType === CATEGORY_TYPE.ATTR_CLUSTER
  }
}

const barCodeSizeRegexp = /^(\d){12,14}$/

/** 計算國際條碼 EAN-13、EAN-14 驗證碼 */
const calculateBarcodeCheckDigit = (code) => {
  if (!barCodeSizeRegexp.test(code)) {
    throw new Error('Invalid EAN-13 or EAN-14 code')
  }
  let sum = 0
  let i = 0
  let charVal = 0

  for (i = code.length - 1; i >= 0; i--) {
    charVal = parseInt(code.charAt(i))
    if ((code.length - i) % 2) { sum += charVal * 3 } else { sum += charVal }
  }

  if (sum % 10) { return (10 - (sum % 10)) } else { return 0 }
}

/** 檢驗國際條碼 EAN-13、EAN-14 */
export const isValidBarcode = _.memoize((code = '') => {
  const codeLength = code.length
  if (barCodeSizeRegexp.test(code)) {
    const inputCheckDigit = code.charAt(codeLength - 1)
    const barcodePadding = codeLength === 12 ? '0' : ''
    const dataDigits = barcodePadding + code.substring(0, codeLength - 1)
    const checkDigitResult = '' + calculateBarcodeCheckDigit(dataDigits)
    if (inputCheckDigit === checkDigitResult) {
      return true
    }
  }
  return false
})

export const isNewProductProposal = proposalType => proposalType === PROPOSAL_TYPE.NEW_PRODUCT
/**
 * 包含 newListing 及 newListingByApi
 * newListingByApi 視為 newListing
 */
export const isNewListingProposal = proposalType => getIsProposalTypeNewListing(proposalType)

/**
 * check if the proposalType is involved in UPDATE_xxx
 *
 * @param proposalType
 * @returns
 */
export const isUpdateListingProposal = proposalType => _.includes([
  PROPOSAL_TYPE.UPDATE_COPY,
  PROPOSAL_TYPE.UPDATE_VIDEO,
  PROPOSAL_TYPE.UPDATE_IMAGE,
  PROPOSAL_TYPE.UPDATE_ATTRIBUTE,
  PROPOSAL_TYPE.UPDATE_LISTING,
  // update image & attribute 的 proposalType 直接從 API 取得的話會是跟預期不同
  // 列進來一起判斷
  UPDATE_IMAGE_V2,
  UPDATE_LISTING_ATTRIBUTE
], proposalType)

export const getSupplierFullNameByUser = (user = {}) => {
  const { supplierName = '--', supplierId = '--' } = user
  const supplierFullName = `(${supplierId}) ${supplierName}`
  return supplierFullName
}
export const isNotPhaseOverview = (phase) => (phase && phase !== PROPOSAL_PHASE_TYPE.OVERVIEW)

export const getUniqImagesFromString = str => {
  // 從 html string 中找出所有 img tag 的 src 屬性
  const matches = [...str.matchAll(
    /<img[^>]*src=(["'])(https:\/\/[^"']+\.(?:png|jpe?g|gif|webp))\1[^>]*>/gi
  )].map(m => m[2])
  return _.uniq(matches)
}

export const getLimitCheckImagesFromString = str => {
  const images = getUniqImagesFromString(str)
  const limitCheckImages = _.flow(
    () => _.map(images, url => {
      const [, width, height, type] = url.match(/_(\d+)x(\d+)\.(png|jpe?g|gif|webp)$/i) || [undefined, 0, 0, '']
      return {
        url,
        width: Number(width),
        height: Number(height),
        type: type.toLowerCase()
      }
    }),
    imagesWithSize => _.filter(imagesWithSize, image => {
      const { width, height, type } = image
      // gif 圖片都要檢查大小
      if (type === 'gif') {
        return true
      }

      // 其他圖片只有高度 > 2000 才需要檢查
      return (width !== height) && (height > 2000)
    })
  )()
  return limitCheckImages
}
